export const SCORECARD_GROUP_ELEMENT_ID = 'scorecard_charts'

const SCORECARD_METRIC_ELEMENT_ID_PREFIX = 'scorecard_chart_'

/**
 * Builds the copilot page element id for an individual scorecard metric card.
 * The id follows the `scorecard_chart_{metricId}` convention used by highlight and inspect tools.
 */
export const getScorecardMetricElementId = (metricId: string): string =>
  `${SCORECARD_METRIC_ELEMENT_ID_PREFIX}${metricId}`

/**
 * Extracts the metric id from a scorecard element id.
 * Returns undefined when the id does not use the scorecard metric prefix.
 */
export const parseScorecardMetricElementId = (elementId: string): string | undefined => {
  if (!elementId.startsWith(SCORECARD_METRIC_ELEMENT_ID_PREFIX)) {
    return undefined
  }

  const metricId = elementId.slice(SCORECARD_METRIC_ELEMENT_ID_PREFIX.length)
  return metricId.length > 0 ? metricId : undefined
}

/**
 * Returns whether the element id refers to a single scorecard metric card.
 * Distinguishes per-metric ids from the whole scorecard group id.
 */
export const isScorecardMetricElementId = (elementId: string): boolean =>
  parseScorecardMetricElementId(elementId) != null
